import { render, staticRenderFns } from "./RecentOpportunityResponse.vue?vue&type=template&id=32a1cfd2&"
import script from "./RecentOpportunityResponse.vue?vue&type=script&lang=js&"
export * from "./RecentOpportunityResponse.vue?vue&type=script&lang=js&"
import style0 from "./RecentOpportunityResponse.vue?vue&type=style&index=0&id=32a1cfd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports